module.exports = __webpack_public_path__ + "static/media/forgeticon2.41684833.png";